/* eslint-disable @typescript-eslint/no-explicit-any */
// Helper function to flatten array
const flatten = array => {
  return array.reduce((arr1, element) => {
    if (Array.isArray(element)) {
      return arr1.concat(flatten(element));
    }
    return arr1.concat(element);
  }, []);
};
export default flatten;